class Notifications {
    scheduleNotifications(enable, notifications) {
        // Noop
    }
}

export { Notifications };